import { toast } from 'react-toastify';
import { addComponentCssJsInProject, fetchBuilderAiData } from '../pluginComponentApi';
import { createRedirectUrl } from '../../apiUtils';

export default (editor, opts = {}) => {
  const cmd = editor.Commands;
  const {
    imageModalTitle,
    codeViewOptions,
    commandAiComponentCode,
    refs,
    commands,
    titles,
    types,
    projectId,
    version,
    builderAiEngineURL,
    customWrapperMsg,
    project,
    token,
    promptModalTitle,
    builderAiEnginePromptURL,
  } = opts;
  const { aiModelConfigs } = project || {};
  const hasAiModelConfigs = aiModelConfigs && aiModelConfigs.length > 0;
  const hasActiveAiModelConfig =
    aiModelConfigs && aiModelConfigs.some((config) => config.isEnabled);
  console.log(
    '🚀 ~ AI_Component: commands.js:28 ~ hasActiveAiModelConfig:',
    hasActiveAiModelConfig,
  );
  const activeAiModelConfigs =
    hasAiModelConfigs && aiModelConfigs.filter((config) => config.isEnabled);
  console.log('🚀 ~ AI_Component: commands.js:31 ~ activeAiModelConfigs:', activeAiModelConfigs);
  const { imageToCodeCustomCode, promptToCodeCustomCode } = refs;
  let resetStyle = '';
  let targetComponentId = '';
  const redirectUrl = createRedirectUrl();
  const aiModelConfigurationURL = `${redirectUrl}app-setting/${version}/v/${projectId}/setting/aiModelConfig-section?token=${token}`;

  const appendToContent = (target, content) => {
    if (content instanceof HTMLElement) {
      target.appendChild(content);
    } else if (content) {
      target.insertAdjacentHTML('beforeend', content);
    }
  };

  cmd.add(commands.image_to_code_custom_code, {
    imageToCodeCustomCode,

    run(editor, sender, opts = {}) {
      this.editor = editor;
      this.options = opts;
      this.target = opts.target || editor.getSelected();
      const target = this.target;

      if (target && target.get('editable')) {
        this.showAiComponentCode(target);
      }
    },
    stop(editor) {
      editor.Modal.close();
    },
    async showAiComponentCode(target) {
      const { editor, options } = this;
      const title = options.title || imageModalTitle;
      const content = this.getContent();
      const code = target.get(imageToCodeCustomCode) || '';
      targetComponentId = target.ccid;
      resetStyle = `
        <style>
        #${targetComponentId}[data-gjs-type=${types.imageToCode}]::after {
          content: ""
        }
        </style>
      `;
      editor.Modal.open({ title, content })
        .getModel()
        .once('change:open', () => editor.stopCommand(this.id));
      this.getCodeViewer().setContent(code);
    },
    getPreContent() {},
    getPostContent() {},
    getBreakPoint() {
      const contentBreak = document.createElement('br');
      return contentBreak;
    },
    getContent() {
      const { editor } = this;
      const content = document.createElement('div');
      //Create alert label
      const alertLabel = this.createAlertLabel();
      //Create warning label
      const warningLabel = this.createWarningLabel();
      // Create image upload form
      const form = this.createImageUploadForm(titles, builderAiEngineURL);
      const codeViewer = this.getCodeViewer();
      const pfx = editor.getConfig('stylePrefix');
      content.className = `${pfx}image-to-code`;
      appendToContent(content, this.getPreContent());
      let childComponents = [alertLabel];
      if (!hasAiModelConfigs || !hasActiveAiModelConfig) {
        childComponents.push(warningLabel);
      }
      childComponents.push(...[form, codeViewer.getElement()]);
      this.appendChildComponentsToContent(content, childComponents);
      appendToContent(content, this.getPostContent());
      codeViewer.refresh();
      setTimeout(() => codeViewer.focus(), 0);
      return content;
    },
    appendChildComponentsToContent(content, childrens) {
      childrens.forEach((child) => {
        if (child.id === '' || child.id === undefined) {
          child.style = `display: none; visibility: hidden; height: 0vh;`;
          content.appendChild(child);
        } else {
          content.appendChild(child);

          if (!child.className.includes('no-break')) {
            content.appendChild(this.getBreakPoint());
          }
          if (child.className.includes('two-break')) {
            content.appendChild(this.getBreakPoint());
          }
        }
      });
    },
    // getContentActions() {
    //   const { editor } = this;
    //   const btn = document.createElement('button');
    //   const pfx = editor.getConfig('stylePrefix');

    //   btn.innerHTML = labels.buttonLabel;
    //   btn.className = `${pfx}btn-prim ${pfx}btn-import__image-to-code btn btn-theme-submit btn-sm`;
    //   btn.title = titles.imageButtonTitle;
    //   btn.style = `float: right;`;
    //   btn.onclick = () => this.handleSave();
    //   return btn;
    // },
    createAlertLabel() {
      // Create alert label element
      const alertLabel = document.createElement('div');
      alertLabel.className = 'alert alert-primary my-3 no-break';
      alertLabel.role = 'alert';
      alertLabel.innerHTML = `
        <i class="fa fa-info-circle" aria-hidden="true"></i>
        Upload an image to automatically generate HTML code using AI.`;
      alertLabel.id = 'alertInfo';
      return alertLabel;
    },
    createWarningLabel() {
      // Create alert label element
      const alertLabel = document.createElement('div');
      alertLabel.className = 'alert alert-warning my-3 no-break';
      alertLabel.role = 'alert';
      alertLabel.innerHTML = `
        <i class="fa fa-warning" aria-hidden="true"></i>
        Please configure the AI model in the <a href="${aiModelConfigurationURL}">AI Model Configuration <i class="fa fa-external-link" aria-hidden="true"></i></a> section.`;
      alertLabel.id = 'alertWarning';
      return alertLabel;
    },
    createAlertNote() {
      // Create note element
      const note = document.createElement('div');
      note.className = 'small text-muted font-weight-light mt-3';
      note.role = 'alert';
      note.innerHTML =
        "*Note: The HTML content corresponding CSS and JS code will be stored in the Project's global CSS and JS section respectively.";
      note.id = 'noteInfo';
      return note;
    },
    createImageUploadForm(titles, builderAiEngineURL) {
      // Create alert note
      const note = this.createAlertNote();

      // Create form element
      const form = document.createElement('form');
      form.enctype = 'multipart/form-data';
      form.className = 'no-break';
      form.id = 'imageUploadForm';

      // Create wrapper for file input
      const fileInputWrapper = document.createElement('div');
      fileInputWrapper.className = 'mb-3';

      // Create dropzone element
      const dropzone = document.createElement('div');
      dropzone.className = 'dropzone font-italic';
      dropzone.style = 'border: 2px dashed #c3cfe9; padding: 20px; text-align: center;';
      dropzone.innerHTML =
        'Drag & drop an image here or click to select a file (supported formats: .jpg, .jpeg, .png).';

      // Create file input label
      const fileInputLabel = document.createElement('label');
      fileInputLabel.htmlFor = 'image';
      fileInputLabel.className = 'form-label';
      fileInputLabel.innerHTML = 'Select file';
      fileInputLabel.style = 'display: none;';

      // Create file input element
      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.id = 'image';
      fileInput.name = 'image';
      fileInput.accept = '.jpg, .jpeg, .png';
      fileInput.className = 'form-control form-control-sm';
      fileInput.required = true;
      fileInput.style = 'display: none;';

      // Create image preview element
      const imagePreviewContainer = document.createElement('div');
      imagePreviewContainer.classList.add('mt-3', 'd-flex', 'justify-content-center', 'd-none');
      const imagePreview = document.createElement('img');
      imagePreview.style = 'display: none; margin-top: 10px; max-width: 300px; max-height: 300px;';
      imagePreviewContainer.appendChild(imagePreview);

      // Append file input and image preview to dropzone
      dropzone.appendChild(fileInputLabel);
      dropzone.appendChild(fileInput);

      // Handle drag and drop events
      dropzone.addEventListener('dragover', (e) => {
        e.preventDefault();
        dropzone.style.borderColor = '#0056b3';
      });

      dropzone.addEventListener('dragleave', () => {
        dropzone.style.borderColor = '#c3cfe9';
      });

      dropzone.addEventListener('drop', (e) => {
        e.preventDefault();
        dropzone.style.borderColor = '#c3cfe9';
        const files = e.dataTransfer.files;
        if (files.length) {
          fileInput.files = files;
          dropzone.innerHTML = files[0].name;
          submitButton.disabled = !(dropdown.value || defaultModelType);
          this.displayImagePreview(imagePreviewContainer, imagePreview, files[0]);
        }
      });

      dropzone.addEventListener('click', () => {
        fileInput.click();
      });

      fileInput.addEventListener('change', () => {
        if (fileInput.files.length) {
          dropzone.innerHTML = fileInput.files[0].name;
          submitButton.disabled = !(dropdown.value || defaultModelType);
          this.displayImagePreview(imagePreviewContainer, imagePreview, fileInput.files[0]);
        }
      });

      /**
       * Dropdown to select the AI model for generating code.
       * TODO: Initially hidden, unhide it after plugin implmentation
       */
      // Create dropdown
      const dropdownWrapper = document.createElement('div');
      dropdownWrapper.className = `ai-model-select my-3 ${hasAiModelConfigs ? '' : 'invisible'} `;
      const dropdown = document.createElement('select');
      dropdown.className = 'form-control';
      dropdown.id = 'aiModelSelect';
      dropdown.name = 'aiModelSelect';
      const optionPlaceholder = document.createElement('option');
      optionPlaceholder.value = '';
      optionPlaceholder.text = '- Choose AI Model -';
      dropdown.appendChild(optionPlaceholder);
      
      let defaultModelType = null;
      if (hasAiModelConfigs) {
        const defaultModel = aiModelConfigs.find((config) => config.isEnabled && config.isDefault);
        if (defaultModel) {
          defaultModelType = defaultModel.modelType;
        }
      }

      hasAiModelConfigs &&
        aiModelConfigs.forEach((config) => {
          const { modelType, isEnabled } = config;
          const option = document.createElement('option');
          option.value = modelType;
          option.text = this.toTitleCase(modelType);
          if (!isEnabled) {
            option.disabled = true;
          }
          dropdown.appendChild(option);
          if (defaultModelType && modelType === defaultModelType) {
            option.selected = true;
          }
        });
        
        
      dropdownWrapper.appendChild(dropdown);

      dropdown.addEventListener('change', () => {
        const fileSelected = fileInput.files && fileInput.files.length > 0;
        const modelSelected = dropdown.value || defaultModelType;
        submitButton.disabled = !(fileSelected && modelSelected);
      });

      // Submit button
      const submitButton = document.createElement('button');
      submitButton.type = 'submit';
      submitButton.className = 'btn btn-theme-submit my-3';
      submitButton.innerHTML = `<i class="fa fa-upload" aria-hidden="true"></i> ${titles.imageButtonTitle}`;
      submitButton.style = 'float: right;';
      submitButton.disabled = true; // Initially disabled

      // Create a row for dropdown and submit button
      const buttonRow = document.createElement('div');
      buttonRow.style = 'gap: 20px;';
      buttonRow.className = 'd-flex justify-content-between align-items-center';
      buttonRow.appendChild(dropdownWrapper);
      buttonRow.appendChild(submitButton);

      // Append elements to form
      fileInputWrapper.appendChild(dropzone);
      fileInputWrapper.appendChild(fileInput);
      form.appendChild(fileInputWrapper);
      form.appendChild(note); // Append note after dropzone
      form.appendChild(imagePreviewContainer); // Append imagePreviewContainer after note
      form.appendChild(buttonRow); // Append buttonRow containing dropdown and submit button

      // Add form submit handler
      this.handleFormSubmit(form, submitButton, builderAiEngineURL);
      return form;
    },
    // Function to display image preview
    displayImagePreview(imagePreviewContainer, imagePreview, file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        imagePreview.src = e.target.result;
        imagePreview.style.display = 'block';
        imagePreviewContainer.classList.remove('d-none');
      };
      reader.readAsDataURL(file);
    },
    handleFormSubmit(form, submitButton, builderAiEngineURL) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        // Show loading state
        submitButton.disabled = true;
        submitButton.innerHTML = '<i class="fa fa-spinner fa-spin"></i> Generating...';

        const formData = new FormData(form);
        console.log(
          '🚀 ~ ImageToCode: commands.js:289 ~ form.addEventListener ~ formData:',
          formData,
        );
        const selectedAiModel = formData.get('aiModelSelect');
        let aiCodeGenerationModel, aiSecretkey, aiModelTemperature, aiModelTopP;
        if (selectedAiModel) {
          // Fetch the AI model configuration based on the selected model
          const aiModelConfig = activeAiModelConfigs.find(
            (config) => config.modelType === selectedAiModel,
          );
          const { setting } = aiModelConfig || {};
          // Extract the model settings
          const { modelEngine, secretKey, temperature, topP } = setting || {};
          aiCodeGenerationModel = modelEngine || '';
          aiSecretkey = secretKey || '';
          aiModelTemperature = temperature || '';
          aiModelTopP = topP || '';
        }
        // Add additional form data related to the Builder AI engine
        formData.append('generatedCodeConfig', 'bootstrap');
        formData.append('generationType', 'create');
        formData.append('inputMode', 'image');
        /**
         * Additional form data keys to be added for OpenAI and Anthropics API keys based on the AI plugin configuration.
         * Default OpenAI model:gpt-4o-2024-08-06, Anthropics model:claude-3-5-sonnet-latest
         */
        if (hasAiModelConfigs) {
          if (selectedAiModel) formData.append('aiModel', selectedAiModel);
          if (aiCodeGenerationModel) formData.append('codeGenerationModel', aiCodeGenerationModel);
          if (aiSecretkey) formData.append('apiKey', aiSecretkey);
          if (aiModelTemperature) formData.append('temperature', aiModelTemperature);
          if (aiModelTopP) formData.append('topP', aiModelTopP);
        }

        if (targetComponentId) {
          formData.append('elementId', targetComponentId);
        }

        try {
          // fetching data from the builder ai engine
          const response = await fetchBuilderAiData(builderAiEngineURL, formData);
          if (!response.ok) {
            throw new Error('Upload failed');
          }
          // Handle successful upload
          const result = await response.json();
          const { data } = result || '';
          // Segregate the data into styles, scripts and body
          if (data) {
            let code = data;
            const htmlTagRegex = /<html\b[^>]*>([\s\S]*?)<\/html>/i;
            const hasHtmlTags = htmlTagRegex.test(code);
            console.log(
              '🚀 ~ ImageToCode: commands.js:244 ~ form.addEventListener ~ hasHtmlTags:',
              hasHtmlTags,
            );
            if (!hasHtmlTags) {
              throw new Error('Invalid HTML content');
            }
            const extracted = this.extractTags(code);
            extracted['customWrapperMsg'] = `${customWrapperMsg} #${targetComponentId}`;
            console.log(
              '🚀 ~ ImageToCode: commands.js:245 ~ form.addEventListener ~ extracted:',
              extracted,
            );
            if (extracted.cleanHtmlBody) {
              code = extracted.cleanHtmlBody.trim();
            }
            this.getCodeViewer().setContent(code + resetStyle);
            this.handleSave();
            // Add the extracted styles and scripts to the project for the component
            await addComponentCssJsInProject(projectId, version, extracted);
            toast.success(
              'HTML content generated successfully. Please reload the page to view changes.',
            );
          }
        } catch (error) {
          console.error('Image to UI error:', error);
          toast.error('Something went wrong. Please try again later.');
        } finally {
          // Reset button state
          submitButton.disabled = false;
          submitButton.innerHTML = `<i class="fa fa-upload" aria-hidden="true"></i> ${titles.imageButtonTitle}`;
        }
      });
    },
    extractTags(htmlContent) {
      const scriptRegex = /<script\b[^>]*>([\s\S]*?)<\/script>/gim;
      const styleRegex = /<style\b[^>]*>([\s\S]*?)<\/style>/gim;
      const headRegex = /<head\b[^>]*>([\s\S]*?)<\/head>/gim;
      const bodyRegex = /<body\b[^>]*>([\s\S]*?)<\/body>/gim;
      let cleanHtml = htmlContent;
      // Extract all <script> tags
      const scripts = [];
      let match;
      while ((match = scriptRegex.exec(htmlContent)) !== null) {
        scripts.push(match[0]); // Entire <script> tag and its content
      }

      // Extract all <style> tags
      const styles = [];
      while ((match = styleRegex.exec(htmlContent)) !== null) {
        styles.push(match[0]); // Entire <style> tag and its content
      }

      // Extract <head> content
      const htmlHead = headRegex.exec(htmlContent)[1]; // Entire <head> tag's content

      // Extract <body> content
      const htmlBody = bodyRegex.exec(htmlContent)[1]; // Entire <body> tag's content
      let cleanHtmlBody = htmlBody;

      cleanHtml = cleanHtml.replace(styleRegex, '');
      cleanHtml = cleanHtml.replace(scriptRegex, '');
      cleanHtmlBody = cleanHtmlBody.replace(styleRegex, '');
      cleanHtmlBody = cleanHtmlBody.replace(scriptRegex, '');
      return { scripts, styles, htmlHead, cleanHtml, cleanHtmlBody };
    },
    toTitleCase(str) {
      if (str === 'CLAUDE_AI') {
        return 'Anthropic AI';
      }
      return str
        .toLowerCase()
        .split('_')
        .map((word) =>
          word === 'ai' ? word.toUpperCase() : word.charAt(0).toUpperCase() + word.slice(1),
        )
        .join(' ');
    },
    handleSave() {
      const { editor, target } = this;
      const code = this.getCodeViewer().getContent();
      target.set(imageToCodeCustomCode, code);
      editor.Modal.close();
    },
    getCodeViewer() {
      const { editor } = this;

      if (!this.codeViewer) {
        this.codeViewer = editor.CodeManager.createViewer({
          codeName: 'htmlmixed',
          theme: 'hopscotch',
          readOnly: 0,
          ...codeViewOptions,
        });
      }

      return this.codeViewer;
    },
    ...commandAiComponentCode,
  });

  cmd.add(commands.prompt_to_code_custom_code, {
    promptToCodeCustomCode,

    run(editor, sender, opts = {}) {
      this.editor = editor;
      this.options = opts;
      this.target = opts.target || editor.getSelected();
      const target = this.target;

      if (target && target.get('editable')) {
        this.showAiComponentCode(target);
      }
    },
    stop(editor) {
      editor.Modal.close();
    },
    async showAiComponentCode(target) {
      const { editor, options } = this;
      const title = options.title || promptModalTitle;
      const content = this.getContent();
      const code = target.get(promptToCodeCustomCode) || '';
      targetComponentId = target.ccid;
      resetStyle = `
        <style>
        #${targetComponentId}[data-gjs-type=${types.promptToCode}]::after {
          content: ""
        }
        </style>
      `;
      editor.Modal.open({ title, content })
        .getModel()
        .once('change:open', () => editor.stopCommand(this.id));
      this.getCodeViewer().setContent(code);
    },
    getPreContent() {},
    getPostContent() {},
    getBreakPoint() {
      const contentBreak = document.createElement('br');
      return contentBreak;
    },
    getContent() {
      const { editor } = this;
      const content = document.createElement('div');
      //Create alert label
      const alertLabel = this.createAlertLabel();
      //Create warning label
      const warningLabel = this.createWarningLabel();
      // Create prompt upload form
      const form = this.createPromptForm(titles, builderAiEnginePromptURL);
      const codeViewer = this.getCodeViewer();
      const pfx = editor.getConfig('stylePrefix');
      content.className = `${pfx}prompt-to-code`;
      appendToContent(content, this.getPreContent());
      let childComponents = [alertLabel];
      if (!hasAiModelConfigs || !hasActiveAiModelConfig) {
        childComponents.push(warningLabel);
      }
      childComponents.push(...[form, codeViewer.getElement()]);
      this.appendChildComponentsToContent(content, childComponents);
      appendToContent(content, this.getPostContent());
      codeViewer.refresh();
      setTimeout(() => codeViewer.focus(), 0);
      return content;
    },
    appendChildComponentsToContent(content, childrens) {
      childrens.forEach((child) => {
        if (child.id === '' || child.id === undefined) {
          child.style = `display: none; visibility: hidden; height: 0vh;`;
          content.appendChild(child);
        } else {
          content.appendChild(child);

          if (!child.className.includes('no-break')) {
            content.appendChild(this.getBreakPoint());
          }
          if (child.className.includes('two-break')) {
            content.appendChild(this.getBreakPoint());
          }
        }
      });
    },
    createAlertLabel() {
      // Create alert label element
      const alertLabel = document.createElement('div');
      alertLabel.className = 'alert alert-primary my-3 no-break';
      alertLabel.role = 'alert';
      alertLabel.innerHTML = `
        <i class="fa fa-info-circle" aria-hidden="true"></i>
        Enter a prompt to automatically generate HTML code using AI.`;
      alertLabel.id = 'alertInfo';
      return alertLabel;
    },
    createWarningLabel() {
      // Create alert label element
      const alertLabel = document.createElement('div');
      alertLabel.className = 'alert alert-warning my-3 no-break';
      alertLabel.role = 'alert';
      alertLabel.innerHTML = `
        <i class="fa fa-warning" aria-hidden="true"></i>
        Please configure the AI model in the <a href="${aiModelConfigurationURL}">AI Model Configuration <i class="fa fa-external-link" aria-hidden="true"></i></a> section.`;
      alertLabel.id = 'alertWarning';
      return alertLabel;
    },
    createAlertNote() {
      // Create note element
      const note = document.createElement('div');
      note.className = 'small text-muted font-weight-light mt-3';
      note.role = 'alert';
      note.innerHTML =
        "*Note: The HTML content corresponding CSS and JS code will be stored in the Project's global CSS and JS section respectively.";
      note.id = 'noteInfo';
      return note;
    },
    createPromptForm(titles, builderAiEnginePromptURL) {
      // Create alert note
      const note = this.createAlertNote();

      // Create form element
      const form = document.createElement('form');
      form.enctype = 'multipart/form-data';
      form.className = 'no-break';
      form.id = 'promptToCodeForm';

      // Create wrapper for textarea input
      const textareaWrapper = document.createElement('div');
      textareaWrapper.className = 'mb-3';

      // Create textarea element
      const textarea = document.createElement('textarea');
      textarea.id = 'userPrompt';
      textarea.name = 'userPrompt';
      textarea.className = 'form-control form-control-sm';
      textarea.required = true;
      textarea.placeholder = 'Enter your text prompt here...';
      textarea.rows = 5;
      // Append textarea to wrapper
      textareaWrapper.appendChild(textarea);

      textarea.addEventListener('change', () => {
        if (textarea.value) {
          submitButton.disabled = !(dropdown.value || defaultModelType);
        }
      });

      textarea.addEventListener('input', () => {
        if (textarea.value.trim()) {
          submitButton.disabled = !(dropdown.value || defaultModelType);
        } else {
          submitButton.disabled = true;
        }
      });
      
      

      /**
       * Dropdown to select the AI model for generating code.
       * TODO: Initially hidden, unhide it after plugin implmentation
       */
      // Create dropdown
      const dropdownWrapper = document.createElement('div');
      dropdownWrapper.className = `ai-model-select my-3 ${hasAiModelConfigs ? '' : 'invisible'} `;
      const dropdown = document.createElement('select');
      dropdown.className = 'form-control';
      dropdown.id = 'aiModelSelect';
      dropdown.name = 'aiModelSelect';
      const optionPlaceholder = document.createElement('option');
      optionPlaceholder.value = '';
      optionPlaceholder.text = '- Choose AI Model -';
      dropdown.appendChild(optionPlaceholder);

      let defaultModelType = null;
      if (hasAiModelConfigs) {
        const defaultModel = aiModelConfigs.find((config) => config.isEnabled && config.isDefault);
        if (defaultModel) {
          defaultModelType = defaultModel.modelType;
        }
      }

      hasAiModelConfigs &&
        aiModelConfigs.forEach((config) => {
          const { modelType, isEnabled } = config;
          const option = document.createElement('option');
          option.value = modelType;
          option.text = this.toTitleCase(modelType);
          if (!isEnabled) {
            option.disabled = true;
          }
          if (defaultModelType && modelType === defaultModelType) {
            option.selected = true;
          }

          dropdown.appendChild(option);
        });

      dropdownWrapper.appendChild(dropdown);

      dropdown.addEventListener('change', () => {
        const isPromptFilled = textarea.value.trim() !== '';
        const isModelSelected = dropdown.value || defaultModelType;
        submitButton.disabled = !(isPromptFilled && isModelSelected);
      });

      // Submit button
      const submitButton = document.createElement('button');
      submitButton.type = 'submit';
      submitButton.className = 'btn btn-theme-submit my-3';
      submitButton.innerHTML = `<i class="fa fa-magic" aria-hidden="true"></i> ${titles.promptButtonTitle}`;
      submitButton.style = 'float: right;';
      submitButton.disabled = true; // Initially disabled

      // Create a row for dropdown and submit button
      const buttonRow = document.createElement('div');
      buttonRow.style = 'gap: 20px;';
      buttonRow.className = 'd-flex justify-content-between align-items-center';
      buttonRow.appendChild(dropdownWrapper);
      buttonRow.appendChild(submitButton);

      // Append elements to form
      form.appendChild(textareaWrapper);
      form.appendChild(note); // Append note after textarea
      form.appendChild(buttonRow); // Append buttonRow containing dropdown and submit button

      // Add form submit handler
      this.handleFormSubmit(form, submitButton, builderAiEnginePromptURL);
      return form;
    },
    handleFormSubmit(form, submitButton, builderAiEnginePromptURL) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        // Show loading state
        submitButton.disabled = true;
        submitButton.innerHTML = '<i class="fa fa-spinner fa-spin"></i> Generating...';

        const formData = new FormData(form);
        console.log(
          '🚀 ~ PromptToCode: commands.js:289 ~ form.addEventListener ~ formData:',
          formData,
        );
        const selectedAiModel = formData.get('aiModelSelect');
        let aiCodeGenerationModel, aiSecretkey, aiModelTemperature, aiModelTopP;
        if (selectedAiModel) {
          // Fetch the AI model configuration based on the selected model
          const aiModelConfig = activeAiModelConfigs.find(
            (config) => config.modelType === selectedAiModel,
          );
          const { setting } = aiModelConfig || {};
          // Extract the model settings
          const { modelEngine, secretKey, temperature, topP } = setting || {};
          aiCodeGenerationModel = modelEngine || '';
          aiSecretkey = secretKey || '';
          aiModelTemperature = temperature || '';
          aiModelTopP = topP || '';
        }
        // Add additional form data related to the Builder AI engine
        formData.append('generatedCodeConfig', 'bootstrap');
        formData.append('generationType', 'create');
        formData.append('inputMode', 'prompt');
        /**
         * Additional form data keys to be added for OpenAI and Anthropics API keys based on the AI plugin configuration.
         * Default OpenAI model:gpt-4o-2024-08-06, Anthropics model:claude-3-5-sonnet-latest
         */
        if (hasAiModelConfigs) {
          if (selectedAiModel) formData.append('aiModel', selectedAiModel);
          if (aiCodeGenerationModel) formData.append('codeGenerationModel', aiCodeGenerationModel);
          if (aiSecretkey) formData.append('apiKey', aiSecretkey);
          if (aiModelTemperature) formData.append('temperature', aiModelTemperature);
          if (aiModelTopP) formData.append('topP', aiModelTopP);
        }

        if (targetComponentId) {
          formData.append('elementId', targetComponentId);
        }

        // Convert FormData to JSON
        const jsonObject = {};
        formData.forEach((value, key) => {
          jsonObject[key] = value;
        });
        const jsonBody = JSON.stringify(jsonObject);
        console.log('🚀 ~ PromptToCode ~ jsonBody:', jsonBody);

        try {
          // fetching data from the builder ai engine
          const response = await fetchBuilderAiData(
            builderAiEnginePromptURL,
            jsonBody,
            version,
            true,
          );
          if (!response.ok) {
            throw new Error('Failed to generate code');
          }
          // Handle successful upload
          const result = await response.json();
          const { data } = result || '';
          // Segregate the data into styles, scripts and body
          if (data) {
            let code = data;
            const htmlTagRegex = /<html\b[^>]*>([\s\S]*?)<\/html>/i;
            const hasHtmlTags = htmlTagRegex.test(code);
            console.log(
              '🚀 ~ PromptToCode: commands.js:244 ~ form.addEventListener ~ hasHtmlTags:',
              hasHtmlTags,
            );
            if (!hasHtmlTags) {
              throw new Error('Invalid HTML content');
            }
            const extracted = this.extractTags(code);
            extracted['customWrapperMsg'] = `${customWrapperMsg} #${targetComponentId}`;
            console.log(
              '🚀 ~ PromptToCode: commands.js:245 ~ form.addEventListener ~ extracted:',
              extracted,
            );
            if (extracted.cleanHtmlBody) {
              code = extracted.cleanHtmlBody.trim();
            }
            this.getCodeViewer().setContent(code + resetStyle);
            this.handleSave();
            // Add the extracted styles and scripts to the project for the component
            await addComponentCssJsInProject(projectId, version, extracted);
            toast.success(
              'HTML content generated successfully. Please reload the page to view changes.',
            );
          }
        } catch (error) {
          console.error('Prompt to UI error:', error);
          toast.error('Something went wrong. Please try again later.');
        } finally {
          // Reset button state
          submitButton.disabled = false;
          submitButton.innerHTML = `<i class="fa fa-magic" aria-hidden="true"></i> ${titles.promptButtonTitle}`;
        }
      });
    },
    extractTags(htmlContent) {
      const scriptRegex = /<script\b[^>]*>([\s\S]*?)<\/script>/gim;
      const styleRegex = /<style\b[^>]*>([\s\S]*?)<\/style>/gim;
      const headRegex = /<head\b[^>]*>([\s\S]*?)<\/head>/gim;
      const bodyRegex = /<body\b[^>]*>([\s\S]*?)<\/body>/gim;
      let cleanHtml = htmlContent;
      // Extract all <script> tags
      const scripts = [];
      let match;
      while ((match = scriptRegex.exec(htmlContent)) !== null) {
        scripts.push(match[0]); // Entire <script> tag and its content
      }

      // Extract all <style> tags
      const styles = [];
      while ((match = styleRegex.exec(htmlContent)) !== null) {
        styles.push(match[0]); // Entire <style> tag and its content
      }

      // Extract <head> content
      const htmlHead = headRegex.exec(htmlContent)[1]; // Entire <head> tag's content

      // Extract <body> content
      const htmlBody = bodyRegex.exec(htmlContent)[1]; // Entire <body> tag's content
      let cleanHtmlBody = htmlBody;

      cleanHtml = cleanHtml.replace(styleRegex, '');
      cleanHtml = cleanHtml.replace(scriptRegex, '');
      cleanHtmlBody = cleanHtmlBody.replace(styleRegex, '');
      cleanHtmlBody = cleanHtmlBody.replace(scriptRegex, '');
      return { scripts, styles, htmlHead, cleanHtml, cleanHtmlBody };
    },
    toTitleCase(str) {
      if (str === 'CLAUDE_AI') {
        return 'Anthropic AI';
      }
      return str
        .toLowerCase()
        .split('_')
        .map((word) =>
          word === 'ai' ? word.toUpperCase() : word.charAt(0).toUpperCase() + word.slice(1),
        )
        .join(' ');
    },
    handleSave() {
      const { editor, target } = this;
      const code = this.getCodeViewer().getContent();
      target.set(promptToCodeCustomCode, code);
      editor.Modal.close();
    },
    getCodeViewer() {
      const { editor } = this;

      if (!this.codeViewer) {
        this.codeViewer = editor.CodeManager.createViewer({
          codeName: 'htmlmixed',
          theme: 'hopscotch',
          readOnly: 0,
          ...codeViewOptions,
        });
      }

      return this.codeViewer;
    },
    ...commandAiComponentCode,
  });
};
